/**
 * Lab Aggregate My P/L New — `/aggregate/master-dashboard-new`
 * (`AggregateMasterDashboardNewCtrl` + BigQuery-API getPLBySubGameForAggregator).
 * Strix wires Aggregate-API `…Bq` routes (BigQuery settlement, 7-day max).
 */

export {
  LAB_MY_PNL_SUB_GAMES,
  labMyPnlEventTypes,
  labMyPnlFiltersNarrowed,
  labMyPnlHidesDrilldown,
  labMyPnlHidesEventFilters,
  labMyPnlRangeDayCount,
  labMyPnlTone,
  type LabMyPnlSubGame,
} from './myPnl'

/** Lab BigQuery-API Aggregate New: date diff must not exceed 7 days. */
export const LAB_MY_PNL_NEW_MAX_RANGE_DAYS = 7

export function labMyPnlNewRangeTooLong(from: string, to: string): boolean {
  const a = Date.parse(`${from}T00:00:00`)
  const b = Date.parse(`${to}T00:00:00`)
  if (!Number.isFinite(a) || !Number.isFinite(b)) return false
  const days = Math.ceil(Math.abs(b - a) / (1000 * 60 * 60 * 24))
  return days > LAB_MY_PNL_NEW_MAX_RANGE_DAYS
}
